<template>
  <div class="app-container">
    <el-form :model="queryParams" ref="queryForm" label-width="101px">
      <el-row :gutter="10" class="mb8">
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="互动员工" prop="replyUserId">
            <el-select
              v-model="queryParams.replyUserId"
              placeholder="请选择"
              clearable
              style="width:100%"
            >
              <el-option
                v-for="dict in replyOptions"
                :key="dict.userId"
                :label="dict.nickName"
                :value="dict.userId"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="是否回复" prop="status">
            <el-select
              v-model="queryParams.status"
              placeholder="请选择"
              clearable
              style="width:100%"
            >
              <el-option
                v-for="dict in statusOptions"
                :key="dict.code"
                :label="dict.name"
                :value="dict.code"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="12">
          <el-form-item label="最新互动时间:" prop="latestInteractTime">
            <el-date-picker v-model="queryParams.latestInteractTime" value-format="yyyy-MM-dd" type="daterange" range-separator="至" @change="dateChange"></el-date-picker>
          </el-form-item>
        </el-col>

        <el-col :xs="24" :md="24" :lg="24" align="right">
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
            <el-button icon="el-icon-refresh" @click="resetQuery">清空</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-table v-loading="loading" :data="dataList">
      <el-table-column label="用户" min-width="120" align="center" prop="nickName" />
      <el-table-column label="备注" min-width="100" align="center" prop="remarkName" />
      <!-- <el-table-column label="手机号" min-width="140" align="center" prop="phoneNumber" /> -->
      <el-table-column label="互动员工" min-width="100" align="center" prop="replyUserName" />
      <el-table-column label="最新互动时间" min-width="170" align="center" prop="latestInteractTime" />
      <el-table-column label="是否回复" min-width="100" align="center">
        <template slot-scope="scope">
          {{scope.row.status === 1 ? '待回复' : '已回复'}}
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="80" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="handleSee(scope.row)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="queryList"
    />
  </div>
</template>

<script>
import { queryInteractList } from "@/api/saas/package";
import { listUserWithOutDataScope } from "@/api/system/user";
import { amountFormat } from "@/utils/index";

export default {
  name: "RecordList",
  data() {
    return {
      statusOptions: [{
        code: 1,
        name: '待回复'
      },{
        code: 2,
        name: '已回复'
      }],
      total: 0,
      loading: false,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        latestInteractTimeEnd: null,
        latestInteractTimeStart: null,
        replyUserId: null,
        status: null
      },
      replyOptions: [], // 回复员工
      dataList: [],
      amountFormat
    };
  },
  created() {
    this.queryList();
    this.listUserWithOutDataScope()
  },
  methods: {
    listUserWithOutDataScope() {
      listUserWithOutDataScope()
        .then(response => {
          this.replyOptions = response.rows || [];
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
        });
    },
    handleSee(row) {
      this.$router.push({
        path: '/briefcase/interact/detail',
        query: {
          interactId: row.interactId
        }
      })
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.queryList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.queryParams.latestInteractTimeEnd = null,
      this.queryParams.latestInteractTimeStart = null,
      this.handleQuery();
    },
    handleAddText() {
      this.$refs.addTextDialogRef.open();
    },
    queryList() {
      console.log("business queryList");
      this.loading = true;
      queryInteractList(this.queryParams)
        .then(response => {
          this.dataList = response.rows || [];
          this.loading = false;
          this.total = response.total
        })
        .catch(error => {
          this.loading = false;
        });
    },
    dateChange(e){
      console.log('ee', e)
      if(e){
        this.queryParams.latestInteractTimeStart = e[0]
        this.queryParams.latestInteractTimeEnd = e[1]
      }else {
        this.queryParams.latestInteractTimeStart = null
        this.queryParams.latestInteractTimeEnd = null
      }
    }
  }
};
</script>
